export default __webpack_public_path__ + "static/media/EG_ReSynth-3.001d6b43.wav";